<div class="poin__container">
    @if( data.ribbon_img && data.ribbon_img.length > 0 || data.ribbon_text && data.ribbon_text.length > 0) {
    <div class="ribbon__wrap"
        [ngClass]="data.ribbon_img && data.ribbon_img.length > 0 ? 'bg-primary-tsel-White' : 'bg-[#f6ab2f]'">
        @if (data.ribbon_text && data.ribbon_text.length > 0) {
        <div class="ribbon__text">{{data.ribbon_text}}</div>
        }@else {
        <div class="ribbon__image">
            <img [src]="data.ribbon_img" alt="">
        </div>
        }
    </div>
    }
    <div class="title">{{data.title}}</div>
    <div class="poin">{{data.poin}}<span>poin</span></div>
</div>
